// DEV_MOCK - Set to true to bypass real API calls and test the UI flow.
// Set to false before merging to production.
export const DEV_MOCK = false;

// ─── Scenario definitions ───────────────────────────────────────────────────

// GG-3281: Free trial cancellation
// User signed up, has Stripe trial subscription, hasn't been charged yet
export const MOCK_FREE_TRIAL = {
  purchasedSeats: 1,
  minimumSeats: 1,
  activeUsers: 1,
  availableSeats: 0,
  customerType: 'seat_based' as const,
  billingTerm: 'quarterly',
  nextBillingDate: null,
  pricePerSeat: 75,
  currency: 'usd',
  subscriptionStatus: 'trialing',
  billingStatus: 'active',
  trialEndDate: '2026-06-17T00:00:00Z',
  cancelAtPeriodEnd: false,
  planType: 'starter' as const,
  salesChannel: 'plg' as const,
  selfServiceCancellation: true,
};

// GG-3282 (6A): Paid quarterly plan cancellation
// User is paying quarterly, past trial, active subscription
export const MOCK_PAID_QUARTERLY = {
  purchasedSeats: 5,
  minimumSeats: 1,
  activeUsers: 3,
  availableSeats: 2,
  customerType: 'seat_based' as const,
  billingTerm: 'quarterly',
  nextBillingDate: '2026-09-01T00:00:00Z',
  pricePerSeat: 75,
  currency: 'usd',
  subscriptionStatus: 'active',
  billingStatus: 'active',
  trialEndDate: null,
  cancelAtPeriodEnd: false,
  planType: 'starter' as const,
  salesChannel: 'plg' as const,
  selfServiceCancellation: true,
};

// GG-3282 (6B): Paid annual plan cancellation
// User is paying annually, past trial, active subscription
export const MOCK_PAID_ANNUAL = {
  purchasedSeats: 10,
  minimumSeats: 1,
  activeUsers: 7,
  availableSeats: 3,
  customerType: 'seat_based' as const,
  billingTerm: 'yearly',
  nextBillingDate: '2027-06-01T00:00:00Z',
  pricePerSeat: 50,
  currency: 'usd',
  subscriptionStatus: 'active',
  billingStatus: 'active',
  trialEndDate: null,
  cancelAtPeriodEnd: false,
  planType: 'starter' as const,
  salesChannel: 'plg' as const,
  selfServiceCancellation: true,
};

// ─── Active scenario ────────────────────────────────────────────────────────
// Change this to test different paths:
//   MOCK_FREE_TRIAL     -> GG-3281: trial user cancellation
//   MOCK_PAID_QUARTERLY -> GG-3282 (6A): quarterly paid user
//   MOCK_PAID_ANNUAL    -> GG-3282 (6B): annual paid user
export const MOCK_SEAT_INFO = MOCK_FREE_TRIAL;
